const messages = {
  es: {
    translations: {
      settingsSidebar: {
        title: "Configuración",
        notificationsSection: "Notificaciones",
        enableAll: "Habilitar todas las notificaciones",
        enableSound: "Habilitar sonido de las notificaciones",
        gestorSection: "Notificaciones (gestor)",
        scopeAll: "Habilitar notificaciones de todas las conversaciones ACEPTADAS",
        scopeMine: "Habilitar notificaciones solo de mis conversaciones",
        scopeDisabled: "Deshabilitar todas las notificaciones",
        appearanceSection: "Apariencia",
        darkMode: "Modo oscuro",
        fontSizeMensagens: "Tamaño de fuente de los mensajes",
        close: "Cerrar",
      },
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        messages: {
          inAttendance: {
            title: "En servicio"
          },
          waiting: {
            title: "Esperando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          disconnectOficialHint: "Las conexiones de canal Meta (WhatsApp oficial, Messenger, Instagram) no se pueden desconectar desde el sistema",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          generateQr: "Generar código QR",
          newDevice: "Vincular nuevo dispositivo",
          connecting: "Conectando",
          connected: "Conectado",
        },
        toolTips: {
          disconnected: {
            title: "WhatsApp desconectado",
            content:
              "La conexión se perdió inesperadamente. Haga clic en 'Intentar de nuevo' para reconectar con el emparejamiento actual.",
          },
          cleanSession: {
            title: "Esperando emparejamiento",
            content:
              "No hay sesión activa para esta conexión (fue desconectada manualmente, cerrada desde el teléfono o el código QR expiró). Haga clic en 'Generar código QR' para vincular un dispositivo.",
          },
          forbidden: {
            title: "Conexión rechazada por WhatsApp",
            content:
              "WhatsApp rechazó esta conexión (normalmente una cuenta baneada o restringida temporalmente). Verifique el estado del número en el teléfono. Puede intentar nuevamente más tarde, o usar 'Vincular nuevo dispositivo' para conectar otro número.",
          },
          duplicateNumber: {
            title: "Número ya conectado en otra sesión",
            content:
              "Este teléfono ya está vinculado en otra conexión de este sistema. Para evitar mensajes duplicados, esta sesión fue desconectada automáticamente. Use 'Generar código QR' para vincular con un número diferente, o elimine esta conexión si ya no la necesita.",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          canal: "Canal",
          connectedNumber: "Número conectado",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado satisfactoriamente.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
        title: "Escanea para conectar",
        connection: "Conexión",
        step1: "Abre WhatsApp en tu teléfono.",
        step2: "Toca **Más opciones (⋮)** o **Ajustes** y luego **Dispositivos vinculados**.",
        step3: "Toca **Vincular un dispositivo**.",
        step4: "Apunta la cámara del teléfono a este código QR.",
        waiting: "Generando el código QR...",
        expires: "El código QR expira en unos segundos y se renueva automáticamente.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Ahorrar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
        conversaNaoEncontrada: "Conversación no encontrada.",
        conversaNaoEncontradaDetalhe: "No existe o pertenece a una conexión a la que no tienes acceso.",
        conversaErroCarregar: "No se pudo cargar esta conversación.",
        conversaTentarNovamente: "Intentar de nuevo",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Linhas",
      },
      tickets: {
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        titleGroup: "Alterar Datos del Grupo",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a la cola",
        fieldQueuePlaceholder: "Seleccione una cola",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Cola",
        assignedHeader: "Trabajando en",
        noTicketsTitle: "¡Nada acá!",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        buttons: {
          accept: "Acceptar",
        },
      },
      newTicketModal: {
        title: "Nuevo lead",
        connection: "Conexión",
        name: "Nombre del contacto",
        number: "Número de teléfono",
        invalidNumber: "Número inválido. Ingrese con DDD (y opcionalmente DDI 55).",
        successNew: "¡Atención iniciada!",
        infoExisting: "Ya existe una atención para este contacto en esta conexión.",
        add: "Añadir",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          tickets: "Tickets",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          queues: "Linhas",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      queues: {
        title: "Linhas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          actions: "Comportamiento",
        },
        buttons: {
          add: "Agregar cola",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Linhas",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la cola.",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
        },
      },
      messagesList: {
        encaminhada: "Reenviado",
        apagadaPeloCliente: "Mensaje eliminado por el cliente",
        apagada: "Mensaje eliminado",
        header: {
          assignedTo: "Asignado a:",
          connection: "Conexión:",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escriba un mensaje o presione '' / '' para usar las respuestas rápidas registradas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        placeholderPending: "Acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        audio: {
          permissaoNegada: "El navegador bloqueó el micrófono para este sitio. Haga clic en el icono junto a la dirección, permita el micrófono y recargue la página.",
          semMicrofone: "No se encontró ningún micrófono. Conecte un micrófono o auricular e inténtelo de nuevo.",
          microfoneEmUso: "El micrófono está siendo usado por otro programa. Ciérrelo e inténtelo de nuevo.",
          contextoInseguro: "Grabar audio solo funciona en una conexión segura (https).",
          falhaGravar: "No se pudo iniciar la grabación",
          semGravacao: "No se grabó nada — mantenga el micrófono unos segundos antes de enviar.",
        },
        midia: {
          tituloVideoGrande: "Video por encima del límite",
          videoGrande: "El video \"{{nome}}\" pesa {{tamanho}}. WhatsApp solo envía videos de hasta {{limite}}. ¿Enviarlo como documento? El contacto recibe el archivo para descargar, en lugar del video reproduciéndose en la conversación.",
          enviarComoDocumento: "Enviar como documento",
          acimaDoTeto: "El archivo \"{{nome}}\" pesa {{tamanho}} y WhatsApp no envía nada por encima de {{limite}}. Reduzca el archivo e inténtelo de nuevo.",
        },
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
      },
      ticketOptionsMenu: {
        delete: "Borrar",
        transfer: "Transferir",
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      forwardMessageModal: {
        title: "Contactos",
        buscar: "Buscar contactos",
        grupo: "Grupo",
        semContatos: "Ningún contacto encontrado en esta conexión.",
        maxContatos: "Puede reenviar a un máximo de {{max}} contactos por vez.",
        sucesso: "Mensaje reenviado a {{total}} contacto(s).",
        parcial: "Mensaje reenviado a {{enviados}} de {{total}} contacto(s). Consulte el log para ver las fallas.",
        nenhumEnviado: "No fue posible reenviar el mensaje a ninguno de los contactos seleccionados.",
        buttons: {
          ok: "Reenviar",
          okContagem: "Reenviar ({{total}})",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        forward: "Reenviar",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      backendErrors: {
        ERR_MIDIA_MUITO_GRANDE:
          "Archivo demasiado grande para WhatsApp. Reduzca el archivo e inténtelo de nuevo.",
        ERR_MIDIA_UPLOAD:
          "No se pudo enviar el adjunto. Inténtelo de nuevo.",
        ERR_ENCAMINHAR_SEM_DESTINATARIOS:
          "Seleccione al menos un contacto para reenviar el mensaje.",
        ERR_ENCAMINHAR_MUITOS_DESTINATARIOS:
          "Demasiados contactos seleccionados para un único reenvío.",
        ERR_ENCAMINHAR_MENSAGEM_APAGADA:
          "Este mensaje fue borrado y no puede ser reenviado.",
        ERR_ENCAMINHAR_TIPO_LOCAL:
          "Este mensaje es interno del sistema y nunca fue enviado a WhatsApp, por lo que no puede ser reenviado.",
        ERR_ENCAMINHAR_SEM_PAYLOAD:
          "Este mensaje no tiene los datos originales de WhatsApp (mensaje antiguo o importado) y no puede ser reenviado.",
        ERR_ENCAMINHAR_OFICIAL_NAO_SUPORTADO:
          "Las conexiones de la API Oficial de Meta solo permiten reenviar mensajes de texto enviados por usted.",
        ERR_ENCAMINHAR_CONTATO_FORA_DO_ESCOPO:
          "Usted no tiene acceso a esta conversación: solo es posible reenviar a contactos ya aceptados bajo su responsabilidad.",
        ERR_ENCAMINHAR_CONTATO_BLOQUEADO:
          "Contacto bloqueado: el mensaje no fue reenviado a él.",
        ERR_MENU_INVALIDO:
          "Menú inválido: son de 1 a 10 opciones y, con más de una sección, todas necesitan título.",
        ERR_BUTTONS_NOT_SUPPORTED_CANAL:
          "Este canal no admite botones. Envíe las opciones como texto.",
        ERR_TIPO_NAO_SUPORTADO_CANAL:
          "Este tipo de mensaje no se puede enviar por Messenger o Instagram.",
        ERR_CANAL_SEM_URL_PUBLICA:
          "La conexión no tiene dirección pública configurada: no se pudo enviar el archivo.",
        ERR_EDIT_LOCAL_MESSAGE:
          "Este mensaje es interno del sistema y no se puede editar en WhatsApp.",
        ERR_EDIT_NOT_SUPPORTED_OFICIAL:
          "Las conexiones de la API Oficial de Meta no permiten editar mensajes.",
        ERR_EDIT_CAPTION_UNAVAILABLE:
          "No se pudo editar la leyenda de este archivo. Envíe el archivo nuevamente con la leyenda correcta.",
        ERR_NO_WAPP_SELECTED:
          "Conexión no seleccionada, seleccione una de la pantalla lead",
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_NOT_CONNECTED:
          "La conexión de WhatsApp se está reconectando. Inténtalo de nuevo en unos instantes; si persiste, verifica la página de conexiones.",
        ERR_META_SEND:
          "Error al enviar por la API de Meta.",
        ERR_META_FORA_JANELA:
          "No es posible responder: el cliente no envía mensajes hace más de 7 días. La conversación solo se reabre cuando él escriba de nuevo.",
        ERR_EXTERNAL_LOGIN:
          "Erro en login externo.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NOME_OBRIGATORIO: "Informe el nombre del contacto.",
        ERR_NUMERO_INVALIDO: "Número inválido. Ingrese con DDD (y opcionalmente DDI 55).",
        ERR_ERP_NOVO_LEAD: "Fallo al crear el lead en el ERP. La atención fue guardada como pendiente.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_MENSAGEM_NAO_ENCONTRADA: "No se pudo encontrar ese mensaje en la conversación.",
        ERR_SEM_PERMISSAO_TICKET:
          "No puede responder en esta conversación. En los grupos, solo quien atiende en la conexión del grupo; en las demás, el responsable o un gestor de la misma sucursal.",
        ERR_TAG_SEM_PERMISSAO:
          "No tiene permiso para usar o modificar esta etiqueta.",
        ERR_TAG_NOT_FOUND:
          "Etiqueta no encontrada.",
        ERR_SEM_PERMISSAO_ASSUMIR_LEAD:
          "No tiene permiso para asumir leads. Solicite el permiso en su registro de usuario.",
        ERR_LISTAGEM_SOBRECARREGADA:
          "El sistema está con muchas consultas en este momento. Espere unos segundos e intente de nuevo.",
        ERR_AUDIO_RAPIDO_INDISPONIVEL:
          "El audio de esta respuesta rápida ya no está disponible en el servidor. Registre la respuesta rápida de nuevo.",
        ERR_MESSAGE_NOT_FOUND: "Mensaje no encontrado.",
        ERR_REACT_LOCAL_MESSAGE: "Este mensaje es interno del sistema, no existe en WhatsApp.",
        ERR_REACTION_INVALID_EMOJI: "Reacción inválida.",
        ERR_ONLINE_FORA_HORARIO_ACESSO:
          "Está fuera de su horario de acceso y no puede ponerse en línea ahora.",
        ERR_ONLINE_OFFLINE_ERP:
          "No se pudo cambiar su estado en línea. Inténtelo de nuevo en unos instantes.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una cola.",
      },
    },
  },
};

export { messages };
